import PropTypes from 'prop-types';

export default PropTypes.shape({
  gridOuter: PropTypes.string,
  gridCol1: PropTypes.string,
  gridCol2: PropTypes.string,
  headline: PropTypes.string,
});
